import React, { useState } from 'react';
import { Alert } from 'antd';
import { CloseIcon } from '../../assets/icons';
import './OpenPop.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const OpenPop = (props) => {
  const { onClose, title, description, art } = props;
  const [isVisible] = useState(true);
  return (
    <>
      {isVisible && (
        <div className='container-fluid'>
          <Alert
            message={
              <>
                <div className='openpop-wrapper'>
                  <div className='openpop'>
                    <div className='openpop__data'>
                      <h4 className='mb-16'>{title}</h4>
                      <p>{description}</p>
                    </div>
                    <div className='openpop__art'>
                      <LazyLoadImage src={art} alt='Our hand-picked ' />
                    </div>
                  </div>
                </div>
              </>
            }
            type='warning'
            closable
            closeIcon={<CloseIcon size='15' color='#958B88' />}
            onClose={onClose}
          />
        </div>
      )}
    </>
  );
};

export default OpenPop;
